import React from 'react';
import WorkImg1 from '../img/our-work1.png';
import WorkImg2 from '../img/our-work2.png';
import WorkImg3 from '../img/our-work3.png';
import WorkImg4 from '../img/our-work4.png';
import WorkImg5 from '../img/our-work5.png';
import WorkImg6 from '../img/our-work6.png';
import workImg7 from '../img/our-work-7.png'
import workImg8 from '../img/our-work-8.png'

const OurWorks = () => {
  const images = [
    WorkImg1,
    WorkImg2,
    WorkImg3,
    WorkImg4,
    WorkImg5,
    WorkImg6,
    workImg7,
    workImg8
  ];

  return (
    <section className="our-works-section">
      <div className="our-works-container">
        <h2 className="our-works-title">Gallery</h2>
        <p className="our-works-description">
          Take a look at some of our latest images. We believe in on-time service.
        </p>

        <div className="our-works-gallery">
          {images.map((image, index) => (
            <div key={index} className="our-works-image">
              <img src={image} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurWorks;
